"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assign = exports.shallowClone = exports.beforeInit = void 0;
/**
 * 用于递归判断UIP下是否含有对应子模块
 * 实际检测需要支持多级子模块，所以递归实现
 * qs：UIP.interface.assets
 *  */
var getModule = function (val, key) {
    if (!val || !key || !key.trim())
        return val;
    var _a = key.split('.'), sub1 = _a[0], sub2 = _a.slice(1);
    return getModule(val[sub1], sub2.join('.'));
};
/**
 * 通用前置检测
 * 检测前置依赖的模块数组是否存在
 */
exports.beforeInit = function (UIP) { return function () {
    var modules = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        modules[_i] = arguments[_i];
    }
    if (!UIP || typeof UIP !== 'object' || modules.some(function (v) { return !getModule(UIP, v); })) {
        console.error("This module must be pre dependent on UIP and \n            " + modules.join(',') + " module,please install base modules and try again");
        throw Error();
    }
    return true;
}; };
/** clone UIP，防止UIP对象方法全局污染，沙箱操作
 * class私有方法以及属性,默认不会被遍历，需要额外处理
 */
exports.shallowClone = function (http) {
    var _http = __assign({}, http);
    /** 绑定class的私有方法 */
    _http.__proto__ = http.__proto__;
    return _http;
};
/**
 * 处理接口自带的config，和http参数合并的场景
 * 针对对象参数是object做到合并至第二层,不做深拷贝
 */
exports.assign = function (obj1, obj2) {
    /** 先合并一层保证新对象取到全部的key */
    var newObj = __assign(__assign({}, obj1), obj2);
    if (obj2) {
        for (var key in newObj) {
            if (newObj.hasOwnProperty(key) && typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                newObj[key] = __assign(__assign({}, obj1[key]), obj2[key]);
            }
        }
    }
    return newObj;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-assets/node_modules/@uip-alpha/interface-utils/dist/common/init.js
// module id = lXU2
// module chunks = 1